import { connect } from "react-redux";
import ForgotPassword from "./ForgotPassword";
import { forgotPassword, clearForgotPasswordLinkSent } from "../../ForgotPassword/forgotPasswordActions";

const mapStateToProps = (state) => ({
  forgot: state.forgot,
});

const mapDispatchToProps = {
  forgotPassword,
  clearForgotPasswordLinkSent,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
